"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const de_json_1 = __importDefault(require("./locale/de.json"));
const en_json_1 = __importDefault(require("./locale/en.json"));
// For formatting see: https://formatjs.io/docs/core-concepts/icu-syntax/#select-format
exports.default = { de: de_json_1.default, en: en_json_1.default };
//# sourceMappingURL=index.js.map